import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../loading.service';

@Component({
    selector: 'app-base',
    templateUrl: './base.component.html',
    styleUrls: ['./base.component.scss'],
    standalone: false
})
export class BaseComponent implements OnInit {
  constructor(public loadingService: LoadingService,
  ) {

  }
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }
}
